import React from "react";
import { SectionTitle } from "../components";
import ImageGallery from "react-image-gallery";
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";
import "./Portfolio.css";

import gamephoto1 from "../images/portfolio/optimised/unityGame1_mini.webp";
import gamephoto2 from "../images/portfolio/optimised/unityGame2_mini.webp";
import gamephoto3 from "../images/portfolio/optimised/unityGame3_mini.webp";
import gamephoto4 from "../images/portfolio/optimised/unityGame4_mini.webp";
import accThumbnail from "../images/portfolio/optimised/acc_tut_mini.webp";
import xperiaTut from "../images/portfolio/optimised/xperia_play_tut_mini.webp";
import ssRivalTut from "../images/portfolio/optimised/ss300_tut_mini.webp";
import w10BatteryTut from "../images/portfolio/optimised/w10_battery_tut_mini.webp";
import pcMini from "../images/portfolio/optimised/pc2_mini.webp";
import moboMini from "../images/portfolio/optimised/mobo_mini.webp";
import mouseMini from "../images/portfolio/optimised/mouse_mini.webp";
import dellMini from "../images/portfolio/optimised/dell_inside_mini.webp";
import xboxMini from "../images/portfolio/optimised/xbox_mobo_mini.webp";
import accPromo from "../images/portfolio/optimised/acc_promo_mini.webp"
import githubLogo from "../images/portfolio/optimised/github-mark.svg"

export const Portfolio = () => {
  const gameGalleryItems1 = [
    {
      original: gamephoto1,
      originalAlt: '3D Racing Game - Car modelling',
    },
    {
      original: gamephoto2,
      originalAlt: '3D Racing Game - Finished car',
    },
    {
      original: gamephoto3,
      originalAlt: '3D Racing Game - First track',
    },
    {
      original: gamephoto4,
      originalAlt: '3D Racing Game - Second track',
    },
  ]

  const tutorialsGalleryItems = [
    {
      original: xperiaTut,
      originalAlt: 'Xperia Play LCD Repair Tutorial',
    },
    {
      original: ssRivalTut,
      originalAlt: 'SteelSeries Rival 300 Switch Repair Tutorial',
    },
    {
      original: w10BatteryTut,
      originalAlt: 'Windows 10 - How To Check Battery Health',
    },
  ]

  const buildsGalleryItems = [
    {
      original: pcMini,
      originalAlt: 'Complete PC Build',
    },
    {
      original: moboMini,
      originalAlt: 'MSI B450 Tomahawk Max with Ryzen 7 3800X',
    },
    {
      original: mouseMini,
      originalAlt: 'Disassembled Genesis Zircon X Mouse',
    },
    {
      original: dellMini,
      originalAlt: 'Repairing of Dell Laptop',
    },
    {
      original: xboxMini,
      originalAlt: 'Xbox 360 Jasper V2 Motherboard',
    },
  ]

  return (
    <>
      <div className="container">
        <div className="section odd 3dGame portfolio">
          <SectionTitle title="3D Racing Game" />
          <ImageGallery
            items={gameGalleryItems1}
            showNav={false}
            showBullets={false}
            showThumbnails={false}
            showPlayButton={false}
            showFullscreenButton={false}
            showIndex={false}
            autoPlay={true}
            disableKeyDown={true}
            slideDuration={800}
            slideInterval={4000}
          />
          <p className="desc">
            One of my first major projects ever made. Before this game I’ve never had any experience with gamedev. I was given task to create basic game for Bachelor’s Thesis. Because of love to motorsport I decided to create simple racing game where one has to set the fastest time on the track. Tricky thing is that the car drifts all the time. Narrow tracks don’t help the player either.
            <br />
            <br />
            Whole concept and “alpha build” was finished in 2 months. Next few months were dedicated to designing tracks and car in Blender, adding new features and fixing bugs. You can chceck source code and build under the links below.
          </p>
          <div className="links">
            <a href="https://github.com/1zboro1/bachelors_thesis_game_sourcecode" target="_blank" rel="noopener noreferrer">Game Source Code</a>
            <a href="https://github.com/1zboro1/racing_game_build" target="_blank" rel="noopener noreferrer">Game Build</a>
          </div>
        </div>
      </div>
      <div className="container even">
        <div className="section even accGuide portfolio">
          <SectionTitle title="ACC Beginners Guide" />
          <div className="imgContainer">
            <a href="https://youtu.be/Gix7S5O9EUM" target="_blank" rel="noopener noreferrer">
              <img src={accThumbnail} alt="ACC Beginners Tutorial" />
            </a>
          </div>
          <p className="desc">
            The <strong>biggest</strong> Assetto Corsa Competizione tutorial for beginners on Polish YouTube*. Video helps newcomers on how to setup the game, where to start the journey, what kind of hardware they need and encourages players to take some time to learn basics of handling and understand cars and tracks. <strong>ACC is my most beloved hobby, as I’m a simracer</strong>.
            <br />
            <br />
            The idea for this video came from a desire to help poeple in the way I think is the easiest to understand for each single person. If sombody still needs help I'll try to do my best to explain something or solve the problem.
          </p>
        </div>
        <p className="smallParagraph">*The biggest ACC tutorial on Polish YouTube on 14th October 2024 (there’s always a chance for a better video in the future). Video only available in Polish.</p>
      </div>
      <div className="container">
        <div className="section odd tutorials portfolio">
          <SectionTitle title="Some More Tutorials" />
          <a href="https://www.youtube.com/playlist?list=PLbbJ6EGEAxKawU-S2n53yYXXwt9eUDnWs" target="_blank" rel="noopener noreferrer">
            <ImageGallery
              items={tutorialsGalleryItems}
              showNav={false}
              showBullets={false}
              showThumbnails={false}
              showPlayButton={false}
              showFullscreenButton={false}
              showIndex={false}
              autoPlay={true}
              disableKeyDown={true}
              slideDuration={800}
              slideInterval={4000}
            />
          </a>
          <p className="desc">
            Even more of my tutorials on YouTube. All of them in Polish only :( but for those who understand Polish these videos can help with DIY screen replacement in Sony Ericsson Xperia Play (yep, I owned one), switches replacement in SteelSeries Rival 300 mouse or checking  battery health in Windows 10. Check whole playlist by clicking thumbnail.
          </p>
        </div>
      </div>
      <div className="container even">
        <div className="section even pcBuilds portfolio">
          <SectionTitle title="PCs being built..." />
          <ImageGallery
            items={buildsGalleryItems}
            showNav={false}
            showBullets={false}
            showThumbnails={false}
            showPlayButton={false}
            showFullscreenButton={false}
            showIndex={false}
            autoPlay={true}
            disableKeyDown={true}
            slideDuration={800}
            slideInterval={4000}
          />
          <p className="desc">
            ...and more! I love building PCs from the scratch as well as repairing them or sorting out problems with OS. I’ve also successfully fixed peripherals like computer mice, steering wheels, controllers etc. With knowledge I have about computers and mobile phones I’m glad to advise people with PC builds, laptop and phone purchases. The best thing about all of this is smile on people’s face.
          </p>
          <p className="bigParagraph">I tried, I’m trying and I will always try to help people the best I can with this stuff!</p>
        </div>
      </div>
      <div className="container">
        <div className="section odd more portfolio">
          <SectionTitle title="More to find" />
          <a href="https://youtu.be/roeJvWpiFB8" target="_blank" rel="noopener noreferrer">
            <div className="imgContainer">
              <img src={accPromo} alt="ACC Promo Short Movie" />
            </div>
            <p>ACC promo to pass a lecture</p>
          </a>
          <a href="https://github.com/1zboro1" target="_blank" rel="noopener noreferrer">
            <img src={githubLogo} alt="GitHub Logo" />
            <p>github.com/1zboro1</p>
          </a>
        </div>
      </div>
    </>
  );
};
